import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@shared/services/global.service';
import { MessagingService } from '@shared/services/messaging.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  public appPages = [
    { title: 'Iox', url: '/folder/Inbox', icon: 'mail' },
    { title: 'Outbox', url: '/folder/Outbox', icon: 'paper-plane' },
    { title: 'Favorites', url: '/folder/Favorites', icon: 'heart' },
    { title: 'Archived', url: '/folder/Archived', icon: 'archive' },
    { title: 'Trash', url: '/folder/Trash', icon: 'trash' },
    { title: 'Spam', url: '/folder/Spam', icon: 'warning' },
  ];
  public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];
  constructor(private messagingService: MessagingService, protected _globalService: GlobalService) {}

  ngOnInit() {
    this._globalService.init();
    this.messagingService.init();
  }
}
